import { useImperativeHandle } from 'react';

import type { IValidatorRef } from './types';
import { useValidator } from '../../external/useValidator/useValidator';

export const useValidatorRef = (refObject?: React.RefObject<IValidatorRef>): IValidatorRef => {
  const context = useValidator();

  useImperativeHandle(refObject, () => ({
    validate: context.validate,
  }));

  return context;
};
